// extracted by mini-css-extract-plugin
export default {"inner":"responsive-styles_inner__UOCUs","banner":"responsive-styles_banner__by9Q5","text":"responsive-styles_text__sy0+f"};